import React from "react";
import { Route } from "react-router-dom";
import { useSelector } from 'react-redux';

import OrganisationCreate from './pages/create-organisation'
import RedirectRenderer from "src/components/redirect-renderer";

const Layout = ({ children }) => {
  return (
    <div id="content">
      <div className="mt-4 mb-8">
        {children}
      </div>
    </div>
  )
};

const redirects = [
  { from: '/organisations', to: '/admin/organisations' },
];

const Payments = () => {
  const { organisation: { organisations, is_admin } } = useSelector((state) => state);

  if (typeof organisations === 'object' && is_admin === true) {
    return (
      <React.Fragment>

        {RedirectRenderer({ redirects })}

        <Route exact path={`/admin/create-organisation`} component={() => <Layout><OrganisationCreate /></Layout>} />

      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default Payments;
